<template>
    <div class="w-100 m-auto py-5 py-md-4 align-items-center justify-content-center">
        <banner v-if="!!banner" :bannerText="'MATCHMAKER4BUSINESS'" />
        <div
            class="register m-auto d-flex align-items-center justify-content-center"
            :class="['form-page-' + formPage]"
        >
            <b-container class="w-100 h-100" :style="quickCenter">
                <template v-if="formPage == 1">
                    <information @fully-scrolled="handleInfoScroll" />

                    <div class="mt-4 d-sm-flex justify-content-between">
                        <b-button
                            @click="formIndex(false)"
                            variant="outline-secondary"
                            size="sm"
                            class="w-100 mb-2 mb-sm-0 mx-auto mx-sm-0 d-block"
                            >Back</b-button
                        >
                        <b-button
                            @click="formIndex(true)"
                            :disabled="!termsBottom"
                            variant="secondary"
                            size="sm"
                            class="mx-auto mx-sm-0 d-block"
                            >I accept the Terms of Use</b-button
                        >
                    </div>
                </template>
                <template v-if="formPage == 2">
                    <div class="account-form">
                        <h3
                            class="
								mb-4
								ff-secondary
								fs-title
								text-center
							"
                        >
                            Account Information
                        </h3>

                        <validation-observer
                            ref="formValidator"
                            v-slot="{ handleSubmit }"
                        >
                            <form @submit.prevent="handleSubmit(onSubmit)">
                                <b-container v-loading="loading" class="px-0">
                                    <v-select
                                        v-if="!isWorkforceContext"
                                        @input="
                                            option =>
                                                setPractice(
                                                    !option ? null : option.value
                                                )
                                        "
                                        :value="selectedTypeOption"
                                        placeholder="Practice"
                                        :options="typeOptions"
                                        class="mb-3"
                                    ></v-select>

                                    <b-row>
                                        <b-col>
                                            <t-input
                                                alternative
                                                class="mb-3"
                                                name="firstName"
                                                label="First Name"
                                                v-model="form.firstName"
                                                autocomplete="formname"
                                                mode="lazy"
                                                :rules="{
                                                    required: true
                                                }"
                                            />
                                        </b-col>
                                        <b-col>
                                            <t-input
                                                alternative
                                                class="mb-3"
                                                name="lastName"
                                                label="Last Name"
                                                v-model="form.lastName"
                                                autocomplete="formname"
                                                mode="lazy"
                                                :rules="{
                                                    required: true
                                                }"
                                            />
                                        </b-col>
                                        <t-input
                                            alternative
                                            class="mb-2"
                                            name="email"
                                            label="Email"
                                            v-model="form.email"
                                            autocomplete="formname"
                                            mode="lazy"
                                            :rules="{ required: true, email: true }"
                                        />
                                        <b-form-text id="email-help-block" class="mb-3">
                                            We will send you a confirmation email from
                                            <a
                                                :href="
                                                    `mailto:${getEnv(
                                                        'VUE_APP_SUPPORT_EMAIL'
                                                    )}`
                                                "
                                                >{{
                                                    getEnv('VUE_APP_SUPPORT_EMAIL')
                                                }}</a
                                            >
                                        </b-form-text>
                                    </b-row>

                                    <b-row>
                                        <b-col>
                                            <t-input
                                                alternative
                                                class="mb-3"
                                                name="password1"
                                                :rules="{
                                                    required: true,
                                                    minLength: 8
                                                }"
                                                label="Password"
                                                type="password"
                                                v-model="form.password1"
                                                autocomplete="new-password"
                                            />
                                        </b-col>
                                        <b-col>
                                            <t-input
                                                alternative
                                                class="mb-3"
                                                name="password2"
                                                label="Confirm Password"
                                                :rules="{
                                                    confirmed: 'password',
                                                    required: true,
                                                    minLength: 8
                                                }"
                                                type="password"
                                                v-model="form.password2"
                                                autocomplete="new-password"
                                            />
                                        </b-col>
                                    </b-row>
                                </b-container>
                                <div class="mt-4 d-sm-flex justify-content-between">
                                    <b-button
                                        @click="formIndex(false)"
                                        variant="outline-secondary"
                                        siz="sm"
                                        class="w-100 mb-2 mb-sm-0 mx-auto mx-sm-0 d-block"
                                        >Back</b-button
                                    >
                                    <b-button
                                        :disabled="
                                            !!loading || !isRefValid('formValidator')
                                        "
                                        variant="secondary"
                                        size="sm"
                                        type="submit"
                                        class="w-100 mx-auto mx-sm-0 d-block"
                                        >Submit</b-button
                                    >
                                </div>
                            </form>
                        </validation-observer>
                    </div>
                </template>
            </b-container>
        </div>
    </div>
</template>
<script>
import Banner from '@comp/Banner'
import Information from '@comp/Information'
import { mapGetters } from 'vuex'
import UserService from '@serv/UserService'
import NotifyService from '@serv/NotifyService'
import Redirect from '@serv/Redirect'
import EnvMixin from '@mixins/EnvMixin'

export default {
    name: 'Register',
    metaInfo: {
        title: 'Register'
    },
    components: {
        Banner,
        Information
    },
    props: {
        isWorkforceContext: {
            type: Boolean,
            description:
                'If the view is related to the workforce product types, show and register workforce plans',
            default: false
        }
    },
    mixins: [EnvMixin],
    data() {
        return {
            loading: false,
            banner: false,
            formPage: 1,
            errors: false,
            termsBottom: false,
            form: {
                name: '',
                practice: '',
                email: '',
                password1: '',
                password2: ''
            }
        }
    },
    computed: {
        ...mapGetters(['user', 'typeOptions', 'typeOption']),
        forgotPassword() {
            return !!this.passwordToggle ? 'Forgot your password?' : 'Back to login'
        },
        quickCenter() {
            return !!this.banner ? { top: '-68px', position: 'relative' } : ''
        },
        selectedTypeOption() {
            console.log(this.form.description)
            return this.typeOption(this.form.description)
        }
    },
    methods: {
        formIndex(bool) {
            bool ? this.formPage++ : this.revert()
        },
        revert() {
            this.banner = false
            if (this.formPage <= 1) {
                Redirect.gotoName('Home')
            } else {
                this.formPage--
            }
        },
        isRefValid(ref) {
            if (!this.$refs[ref]) return false

            return this.$refs[ref].flags.valid
        },
        setPractice(value) {
            this.form = { ...this.form, description: value }
        },
        async onSubmit() {
            this.loading = true
            const isValid = await this.$refs.formValidator.validate()

            if (!isValid) {
                this.loading = false
                this.errors = isValid
                return
            }

            if (this.form.email && this.form.password1) {
                UserService.createUser(this.form)
                    .then(() => {
                        Redirect.gotoName('Home')
                        NotifyService.notify(
                            this,
                            'An email confirmation link has been sent. Please check your inbox',
                            'success'
                        )
                        this.loading = false
                    })
                    .catch(error => {
                        if (error.email) {
                            NotifyService.notify(this, error.email[0], 'danger')
                        } else {
                            NotifyService.notify(
                                this,
                                'An error has occured - please check the form and try again.',
                                'danger'
                            )
                        }

                        this.loading = false
                    })
            }
        },
        handleInfoScroll(payload) {
            this.termsBottom = payload
        }
    },
    beforeMount() {},
    mounted() {
        document.addEventListener('keypress', e => {
            if (e.key === 'Enter') {
                this.onSubmit()
            }
        })
        this.$bus.$on('change-page', () => {
            this.formIndex(true)
        })
    }
}
</script>

<style lang="scss">
.register.form-page-2,
.register.form-page-1 {
    max-width: 820px;
}
.register {
    padding-top: 35px;

    .btn {
        &.w-100 {
            max-width: 200px;
        }
    }
}
</style>
